/**
 * DERIVED ATOMS
 *
 * Cross-collection derived atoms and computed state
 * These read from multiple atom families to provide useful aggregations
 */

import { atom } from "jotai"

import { classAtoms, classSessionAtoms, studentAtoms } from "./allAtoms"

/**
 * Get all students enrolled in a specific class
 * Reads from both students and class data
 */
export const studentsForClassAtom = atom((get) => {
  return (classId: string) => {
    const allStudents = get(studentAtoms.allDocsAtom)

    return allStudents.filter((student) => {
      return student.attendance?.[classId] != null
    })
  }
})

/**
 * Get all sessions for a specific class
 */
export const sessionsForClassAtom = atom((get) => {
  return (classId: string) => {
    const classDoc = get(classAtoms.docByIdAtom(classId))

    if (!classDoc?.sessionIds) return []

    return classDoc.sessionIds
      .map((sessionId) => get(classSessionAtoms.docByIdAtom(sessionId)))
      .filter(
        (session): session is NonNullable<typeof session> => session !== null
      )
  }
})

/**
 * Get total student count
 */
export const totalStudentsAtom = atom((get) => {
  const allStudents = get(studentAtoms.allDocsAtom)
  return allStudents.length
})

/**
 * Get total class count
 */
export const totalClassesAtom = atom((get) => {
  const allClasses = get(classAtoms.allDocsAtom)
  return allClasses.length
})

// Add more cross-collection derived atoms as needed
// Examples:
// - Students by skill level across all classes
// - Classes by curriculum
// - Upcoming sessions (next 7 days)
// - Students with pending makeups
// - etc.

// console.log("✅ Derived atoms initialized")
